import{a}from"./ninox-components-4KWCCUJ4.js";import{l as r}from"./ninox-components-GQTCIGTF.js";import{m as o}from"./ninox-components-2ADN25D5.js";import{f as n}from"./ninox-components-MYF6AQNE.js";import{k as i}from"./ninox-components-R4FVH3NU.js";import{a as t}from"./ninox-components-I2GBTDK4.js";import l from"styled-components";var b=l(a)`
    position: relative;
    height: ${r.m};
    padding: 0 ${o.small};
    gap: ${o.x_small};

    isolation: isolate;

    font-size: ${i.medium};
    font-weight: ${t.medium};
    text-decoration: none;
    white-space: nowrap;
    border-width: 0;
    outline: none;

    &&,
    &:visited {
        ${({theme:e})=>e.combobox.option.single.default};
        border-style: none;
    }

    &:before {
        content: '';
        position: absolute;
        inset: 0;
        pointer-events: none;

        border-width: 0;
        border-color: inherit;
        border-style: solid;

        transition-property: all;
        transition-timing-function: inherit;
        transition-duration: inherit;
    }

    &:focus-visible:not(:hover) {
        ${({theme:e})=>e.combobox.option.single.focus};
        text-decoration: underline;
    }

    &:hover {
        ${({theme:e})=>e.combobox.option.single.hover};
    }

    &:active,
    &:checked,
    &[aria-current],
    &[aria-checked='true'],
    &[aria-selected='true'] {
        ${({theme:e})=>e.combobox.option.single.active};
    }

    &:is(
            :hover,
            :focus-visible,
            :active,
            :checked,
            [aria-current],
            [aria-pressed='true'],
            [aria-checked='true'],
            [aria-selected='true']
        ):before {
        border-left-width: ${n.smaller};
    }

    &[aria-disabled='true'] {
        ${({theme:e})=>e.combobox.option.single.disabled};
        pointer-events: none;
    }

    &[aria-disabled='true']:before {
        border-left-width: 0;
    }
`,u=l.label`
    display: inline-flex;
    align-items: center;
    box-sizing: border-box;
    flex-shrink: 0;

    position: relative;
    height: ${r.m};
    padding: 0 ${o.small};
    gap: ${o.x_small};

    font-size: ${i.medium};
    font-weight: ${t.medium};
    text-decoration: none;
    user-select: none;
    white-space: normal;
    text-wrap: pretty;
    cursor: pointer;
    outline: none;

    &,
    &:visited {
        ${({theme:e})=>e.combobox.option.multi.default};
    }

    &:focus-visible:not(:hover) {
        ${({theme:e})=>e.combobox.option.multi.focus};
    }

    &:hover {
        ${({theme:e})=>e.combobox.option.multi.hover};
    }

    &:active,
    &:checked,
    &[aria-current],
    &[aria-checked='true'],
    &[aria-selected='true'] {
        ${({theme:e})=>e.combobox.option.multi.active};
    }

    &[aria-disabled='true'] {
        ${({theme:e})=>e.combobox.option.multi.disabled};
    }
`;export{b as a,u as b};
//# sourceMappingURL=ninox-components-K2LZKEH2.js.map